import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=6f883f4b&scoped=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailPage.vue?vue&type=style&index=0&id=6f883f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f883f4b",
  null
  
)

export default component.exports